import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { Button } from '../button';
import { Icon } from '../icon/icon.component';
import { Status } from '../status';
/** A button that only renders an icon without text */

export var IconButton = React.forwardRef(function (_a, ref) {
  var icon = _a.icon,
      pending = _a.pending,
      error = _a.error,
      errorIcon = _a.errorIcon,
      className = _a.className,
      buttonProps = __rest(_a, ["icon", "pending", "error", "errorIcon", "className"]);

  return React.createElement(Button, Object.assign({
    ref: ref
  }, buttonProps, {
    className: ClassNames.concat('arm-icon-button', className),
    statusPosition: undefined
  }), !pending && !error && React.createElement(Icon, {
    iconSet: icon.iconSet,
    icon: icon.icon
  }), React.createElement(Status, {
    errorIcon: errorIcon,
    pending: pending,
    error: error
  }));
});